function getCookieFromDocument(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()!.split(";").shift() || null;
  }
  return null;
}

/**
 * Retrieves the value of the specified cookie in a Axios Response
 * response, or undefined if no such cookie exists.
 *
 * @param {object} res - the response object from a fetch/XHR or redux-query
 * request/mutate promise fulfillment
 * @param {string} name - the name of the cookie to retrieve the value for
 */
export default function getCookie(name: string) {
  return getCookieFromDocument(name);
}
